import Layout from "@app-components/layout.vue";
import NavButton from "@app-components/nav-button/nav-button.vue";
import Spinner from "@app-components/spinner.vue";
import { useSettings } from "@app-composables/settings";
import i18nPlugin from "@app-i18n/plugin";
import EventsManager from "@app-utilities/events-manager";
import { trackUserEvent } from "@app-utilities/observability";
import { AppInsightsEvent } from "@app-utilities/observability-events";
import { createDsy, QButton, QSpinner } from "@qamf/lighthouse";
import { createApp } from "vue";

import AppEntryPoint from "./app.vue";
import boot from "./boot";
import router from "./router";
import store from "./store";

const BowlerApp = createApp(AppEntryPoint);

BowlerApp.component("Spinner", Spinner);
BowlerApp.component("QSpinner", QSpinner);
BowlerApp.component("QButton", QButton);
BowlerApp.component("Layout", Layout);
BowlerApp.component("NavButton", NavButton);

BowlerApp.config.errorHandler = (err, _vm, info) => {
	EventsManager.emitError(err as Error, { info });
};

const setupDsy = () => {
	const {environment, channel} = useSettings();
	const [systemId] = location.pathname.split("/").filter(Boolean);
	const centerId = Number(systemId);
	const isAdvancedTelemetryEnabled
    = environment.value === "development"
	|| environment.value === "staging"
    || (environment.value === "production" && channel.value === "beta" && centerId === 5597);

	BowlerApp.use(createDsy({
		colorMode: "none",
		usageType: "components-only",
		bootstrap: {
			orchestrator: true
		},
		advancedTelemetry: isAdvancedTelemetryEnabled
	}));
};

const updatePwaThemeColor = () => {
	try {
		const color = localStorage.getItem("themeColorPwa") ?? (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");
		const themeColorTag = document.createElement("meta");
		themeColorTag.name = "theme-color";
		themeColorTag.content = color;
		document.head.appendChild(themeColorTag);
	} catch (e) {
		throw new Error("Failed to set PWA theme color", { cause: e });
	}
};

if (!window.structuredClone)
	window.structuredClone = (value: any) => JSON.parse(JSON.stringify(value));

window.addEventListener("load", async() => {
	await boot();
	BowlerApp.use(store);
	BowlerApp.use(router);
	BowlerApp.use(i18nPlugin);
	updatePwaThemeColor();
	setupDsy();
	BowlerApp.mount("#app-main");
	trackUserEvent(AppInsightsEvent.BootCompleted);
});

export default BowlerApp;


